import $ from "jquery"
import React from "react"

import AdfoxIR2 from "./adfox/AdfoxIR2"
import AdfoxTGB4_MT from "./adfox/AdfoxTGB4_MT"
import AdfoxIR3 from "./adfox/AdfoxIR3"
import AdfoxTGB5_MT from "./adfox/AdfoxTGB5_MT"
import AdfoxIR4 from "./adfox/AdfoxIR4"
import AdfoxTGB6_MT from "./adfox/AdfoxTGB6_MT"
import AdfoxIR5 from "./adfox/AdfoxIR5"
import AdfoxTGB7_MT from "./adfox/AdfoxTGB7_MT"
import AdfoxAA1_full from "./adfox/AdfoxAA1_full"
import AdfoxTGB8_MT from "./adfox/AdfoxTGB8_MT"

function calculateChunksCount(chunksLength) {
    const configArray = [
        { chunkLength: 8, config: { adfoxNum: 1, paragraphNum: 3 } },
        { chunkLength: 12, config: { adfoxNum: 2, paragraphNum: 4 } },
        { chunkLength: 16, config: { adfoxNum: 3, paragraphNum: 4 } },
        { chunkLength: 20, config: { adfoxNum: 4, paragraphNum: 4 } }
    ]
    if (chunksLength >= 20) {
        return { adfoxNum: 4, paragraphNum: 5 }
    }
    for (const item of configArray) {
        if (chunksLength < item.chunkLength) {
            return item.config
        }
    }
}

function parseTextFromJson(jsonData) {
    const blocks = JSON.parse(jsonData);
    let text = ''
    blocks.document.nodes.forEach(block => {
        block.nodes.forEach(node => {
            text += `<p>${node.leaves[0].text}</p>`;
        });
    });
    return text
}

function split(news) {
    let el = document.createElement("div")
    if (news.content[0] === '{') {
        el.innerHTML = parseTextFromJson(news.content)
    } else {
        el.innerHTML = news.content
    }
    const chunks = Array.from(el.children).map(el => el.innerHTML)
    const config = calculateChunksCount(chunks.length)
    for (let i = 1; i < config.adfoxNum + 1; i++) {
        chunks.splice(config.paragraphNum * i, 0, "ADFOX")
    }
    return chunks
}

function getAdfoxComponents(mt, context) {
    const adfoxComponents = {
        1: <AdfoxIR2 context={ context } />,
        2: <AdfoxIR3 context={ context } />,
        3: <AdfoxIR4 context={ context } />,
        4: <AdfoxIR5 context={ context } />
    }
    const adfoxMtComponents = {
        1: <AdfoxTGB4_MT />,
        2: <AdfoxTGB5_MT />,
        3: <AdfoxTGB6_MT />,
        4: <AdfoxTGB7_MT />
    }
    return mt ? adfoxMtComponents : adfoxComponents
}

class NewsText extends React.Component {
    constructor(props) {
        super(props)
        this.contentRef = React.createRef()
        this.state = {
            toggle: true,
            currentUrl: ""
        }
        const url = new URL(window.location.href)
        if (url.searchParams.has("full")) {
            this.state.toggle = false
            props.isFull()
        } else {
            this.state.toggle = true
        }
        this.cnt = 1
    }

    componentDidMount() {
        const { news } = this.props

        const url = new URL(window.location.href)
        url.searchParams.set("full", "1")

        // Устанавливаем новый URL в состояние
        this.setState({ currentUrl: url.toString() })

    }

    render() {
        const { news, teasers, onClick, context } = this.props
        const chunks = split(news)
        const url = new URL(window.location.href)
        const mt = url.pathname.includes("news/mt/")
        const adfoxNum = calculateChunksCount(chunks.length)["adfoxNum"]
        const selectedComponentsMap = getAdfoxComponents(mt, context)
        return (
            <div className="newsDetail">
                <div className={ this.state.toggle ? "news-content-inner__toggle" : null } ref={ this.contentRef }>
                    { chunks.map((chunk, i) => {
                        if (chunk === "ADFOX" && this.cnt <= adfoxNum && !this.state.toggle) {
                            this.cnt += 1
                            return selectedComponentsMap[this.cnt - 1]
                        }
                        if (i === chunks.length - 1) {
                            this.cnt = 1
                        }
                        return (
                            <React.Fragment key={ i }>
                                <p hidden={ this.state.toggle && chunk === "ADFOX" }
                                   dangerouslySetInnerHTML={ { __html: chunk } } />
                            </React.Fragment>
                        )
                    }) }
                </div>
                <div className={ this.state.toggle ? "toggleNews" : "hidden" }>
                    <div className={ this.state.toggle ? "fadeNews" : null }></div>
                    <a className={ this.state.toggle ? "openButton" : "hidden" } target="_blank"
                       href={ this.state.currentUrl }>Показать больше</a>
                </div>
                { this.state.toggle ? null : mt ? <AdfoxTGB8_MT /> :
                    <AdfoxAA1_full context={ context } /> }
            </div>
        )
    }
}

NewsText.defaultProps = {
    teasers: []
}

export default NewsText
